module.exports = __webpack_public_path__ + "img/proyecto_13.b7ad3aeb.png";